import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-button',
  template: `
    <button [type]="to.type" [ngClass]="to.style" [disabled]="to.disabled" (click)="onClick($event)">
       {{ to.text }}
     </button> 
 `,
})
export class FormlyFieldButton extends FieldType {
  onClick($event) {
    if (this.to.onClick && this.formState && this.formState.component) {
      let fun: any = this.formState.component[this.to.onClick];
      if (typeof fun == "function")
        fun(this.formState.component, $event);
    }
  }
}